module.exports = __webpack_public_path__ + "img/file-heart.01bcb908.svg";